let msgCount = 0;
let hasUserNavigated = false;
let originalTitle: string;
let isListenerAttached = false;

const handleVisibilityChange = () => {
  if (document.hidden) {
    hasUserNavigated = true;
  } else {
    hasUserNavigated = false;
    if (msgCount > 0) {
      document.title = originalTitle;
      msgCount = 0;
    }
  }
};

export const onAgentMessageEnd = async (): Promise<void> => {
  if (typeof document !== "undefined") {
    if (!isListenerAttached) {
      document.addEventListener("visibilitychange", handleVisibilityChange);
      isListenerAttached = true;
    }

    if (hasUserNavigated) {
      if (msgCount === 0) {
        originalTitle = document.title;
      }
      msgCount++;
      document.title = `(${msgCount}) ${originalTitle}`;
    }
  }
};

export const cleanupNotificationHandler = (): void => {
  if (isListenerAttached) {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    isListenerAttached = false;
  }
};
